import React from "react";
import "./App.scss";
import { About, Work, Testimonial, Header, Footer, Skills } from "./container";
import { NavBar } from "./components";

function App() {
  return (
    <div className="app">
      <NavBar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Testimonial />
      <Footer />
    </div>
  );
}

export default App;
